/**
 * Code generated by scripts/gen-phosphor-icons.mjs. DO NOT EDIT.
 * Phosphor Icons 2.1.1, MIT License. See NOTICE.md.
 */

import {createSinglePathSVG} from './TEMPLATE'

// Phosphor: magnifying-glass (regular)
export const MagnifyingGlass_Stroke2_Corner0_Rounded = createSinglePathSVG({
  viewBox: '0 0 256 256',
  path: 'M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z',
})

// Phosphor: magnifying-glass (fill)
export const MagnifyingGlass_Filled_Stroke2_Corner0_Rounded =
  createSinglePathSVG({
    viewBox: '0 0 256 256',
    path: 'M168,112a56,56,0,1,1-56-56A56,56,0,0,1,168,112Zm61.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88,88,0,1,1,11.32-11.31l50.06,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z',
  })

// Phosphor: magnifying-glass (regular)
export const MagnifyingGlassX_Stroke2_Corner0_Rounded_Large =
  createSinglePathSVG({
    viewBox: '0 0 256 256',
    path: 'M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z',
  })
